import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'NiotaClassicDevicesDeviceDetailsStatistics',
  props: {
    deviceData: {
      type: Object,
      required: false,
      default: null
    },
    periodStatistics: {
      type: Object,
      required: false,
      default: null
    },
    periodOlderStatistics: {
      type: Object,
      required: false,
      default: null
    },
    packetsIncreaseRatio: {
      type: Object,
      required: false,
      default: null
    },
    sendingRate: {
      type: Number,
      required: false,
      default: 0
    },
    validStatistics: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      showDeviceStatistics: false,
      newPacketsbyWS: 0,
      selectedTimeFrame: {
        length: 1,
        name: this.$i18n_t('NiotaClassic.Devices.details.last24')
      },
      timeFrames: [{
        length: 1,
        name: this.$i18n_t('NiotaClassic.Devices.details.last24')
      }, {
        length: 7,
        name: this.$i18n_t('NiotaClassic.Devices.details.lastWeek')
      }, {
        length: 31,
        name: this.$i18n_t('NiotaClassic.Devices.details.lastMonth')
      }]
    };
  },
  computed: _objectSpread({}, mapState('app', ['color']))
};